// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kf-c";
export var backButton = "_kf-4";
export var backIcon = "_kf-5";
export var chevronShortcut = "_kf-6";
export var container = "_kf-1";
export var editor = "_kf-8";
export var editorWrapper = "_kf-7";
export var prefix = "_kf-2";
export var searchIcon = "_kf-3";
export var suffix = "_kf-9";
export var suffixContent = "_kf-a";
export var suffixText = "_kf-b";
export var wrapper = "_kf-0";